import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ReactVimeo from 'components/consumer/ReactVimeo';
import RatioContainer from 'components/consumer/RatioContainer';
import WistiaVideoPlayer from 'components/consumer/WistiaVideoPlayer';

const LivestreamVideoPlayer = ({ fullWidth = false, videoId, videoType }) => {
  const videoPlayerRef = useRef(null);
  if (videoType !== 'vimeo' && videoType !== 'wistia') {
    return null;
  }

  const scrollPlayerIntoView = () => {
    videoPlayerRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  // If video URL was copied while logged into Vimeo, it may be passed into the
  // component in the format https://vimeo.com/manage/videos/560538232 but the
  // only format supported by the Vimeo player is https://vimeo.com/560538232
  const vimeoVideoId = videoId
    ? videoId.replace('/manage/videos', '')
    : videoId;

  return (
    <div
      className={classNames('flex-1', {
        'bg-black flex justify-center': fullWidth,
      })}
    >
      <div
        className={classNames('scroll-mt-5', {
          'flex-1 lg:max-w-[calc(93.334vw_-_3rem_-_233px)] min-[1500px]:max-w-[calc(1167px_-_3rem)]': fullWidth,
        })}
        ref={videoPlayerRef}
      >
        <RatioContainer
          className="[&_iframe]:absolute [&_iframe]:top-0 [&_iframe]:bottom-0 [&_iframe]:left-0 [&_iframe]:right-0 [&_iframe]:w-full [&_iframe]:h-full"
          ratio={9 / 16}
        >
          <div>
            {videoType === 'vimeo' && (
              <ReactVimeo
                video={vimeoVideoId}
                className="flex w-full"
                onLoaded={scrollPlayerIntoView}
              />
            )}

            {videoType === 'wistia' && (
              <WistiaVideoPlayer
                videoId={videoId}
                className="LivestreamVideoPlayer__video--wistia"
                onLoaded={scrollPlayerIntoView}
              />
            )}
          </div>
        </RatioContainer>
      </div>
    </div>
  );
};

LivestreamVideoPlayer.propTypes = {
  fullWidth: PropTypes.bool,
  videoId: PropTypes.string,
  videoType: PropTypes.oneOf(['vimeo', 'wistia']),
};

export default LivestreamVideoPlayer;
